/* eslint-disable no-console */
import { client } from "./supabase";

// ─── Supertipo documentos_fiscales — resolución de identidad ──────────────────
//
// documentos_fiscales es la identidad única del documento fiscal del mundo ER
// (Opción C del plano docs/plan-supertipo-documentos-fiscales.md). Cada fila base
// (facturas_sii_recibidas / _emitidas / facturas_externas / boletas_honorarios)
// tiene su fila surrogate, poblada y mantenida por trigger (auto-población en
// INSERT, cleanup en DELETE — migración 20260827_fase1_documentos_fiscales.sql).
//
// Este helper traduce (tipo, origen_id) → documento_id surrogate. Lo usa el
// dual-write de Fase 3 (plano §"Fase 3"): al escribir la columna typed vieja se
// escribe TAMBIÉN documento_id.

// Resuelve el id surrogate de documentos_fiscales para un (tipo, origen_id).
// Devuelve el id (number) o null. NUNCA tira ni bloquea el flujo viejo: como el
// supertipo está poblado y auto-actualizado por trigger, un null acá es un caso
// ANÓMALO a investigar, no el camino normal — por eso se loguea (10.177/10.170),
// no se traga en silencio, pero el caller sigue escribiendo la columna typed.
export const resolverDocumentoFiscalId = async (tipo, origenId) => {
  if (origenId == null) return null;
  const { data, error } = await client
    .from("documentos_fiscales")
    .select("id")
    .eq("tipo", tipo)
    .eq("origen_id", origenId)
    .maybeSingle();
  if (error) {
    console.warn(`[documentos_fiscales] error resolviendo (${tipo}, ${origenId}): ${error.message}`);
    return null;
  }
  if (!data) {
    console.warn(
      `[documentos_fiscales] SIN match para (${tipo}, ${origenId}) — dual-write de documento_id omitido; ` +
        "la columna typed queda intacta. Caso a investigar (el supertipo debería estar poblado por trigger)."
    );
    return null;
  }
  return data.id;
};

// Enriquece un array de filas (cuotas de plan) con documento_id, resolviendo
// (tipo, fila[campoOrigen]) contra documentos_fiscales. Resuelve UNA vez por
// origen distinto (normalmente 1). Si no resuelve, deja la fila tal cual (la
// columna documento_id queda NULL por default) sin bloquear el insert viejo.
export const conDocumentoId = async (filas, tipo, campoOrigen) => {
  const origenes = [...new Set((filas || []).map((f) => f[campoOrigen]).filter((v) => v != null))];
  const mapa = new Map();
  for (const origen of origenes) {
    mapa.set(origen, await resolverDocumentoFiscalId(tipo, origen));
  }
  return (filas || []).map((f) => {
    const docId = f[campoOrigen] != null ? mapa.get(f[campoOrigen]) : null;
    return docId != null ? { ...f, documento_id: docId } : f;
  });
};
